export const SET_ROUTE_NAME = 'app/SET_ROUTE_NAME'

export const setRouteName = (route) => async (dispatch, getState) => {
  await dispatch({
    type: SET_ROUTE_NAME,
    route,
  })
}
